export interface Article {
  id: string;
  title: string;
  slug: string;
  categorySlug: string;
  summary: string;
  content: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: 'qiaojzx.cn 平台全景概览：一站式服务的全新体验',
    slug: 'platform-overview',
    categorySlug: 'platform-features',
    summary: 'qiaojzx.cn 整合多项核心服务于一体，为用户提供便捷、高效、安全的一站式综合服务体验。本文带您全面了解平台架构与核心功能模块。',
    content: `<p>在数字化浪潮席卷全球的今天，用户对于在线服务的需求已经从单一功能转向综合性、一站式的解决方案。qiaojzx.cn 正是在这样的背景下应运而生，致力于为用户打造一个安全、便捷、高效的综合服务平台。</p>
<h2>平台定位与愿景</h2>
<p>qiaojzx.cn 的核心理念是"让服务触手可及"。我们深知用户在不同场景下的多样化需求，因此将多种核心服务整合到同一个平台中，让用户无需在多个应用之间切换，即可完成从信息查询到业务办理的全流程操作。</p>
<p>平台采用先进的微服务架构设计，确保各项服务模块既相互独立又能高效协同。无论是个人用户还是企业客户，都能在 qiaojzx.cn 找到适合自己的解决方案。</p>
<h2>核心功能模块</h2>
<p>qiaojzx.cn 目前集成了以下几大核心功能模块：</p>
<ul>
<li><strong>智能搜索与推荐：</strong>基于 AI 算法，为您精准匹配最需要的服务内容，节省查找时间。</li>
<li><strong>安全认证体系：</strong>多层加密技术保障您的账户安全，支持多种身份验证方式。</li>
<li><strong>数据处理中心：</strong>高效的数据处理引擎，支持大规模数据分析和可视化展示。</li>
<li><strong>即时通讯系统：</strong>内置即时通讯功能，方便用户与服务提供方实时沟通。</li>
<li><strong>支付结算模块：</strong>集成多种支付方式，交易过程安全透明。</li>
<li><strong>用户管理中心：</strong>完整的个人账户管理体系，操作记录一目了然。</li>
</ul>
<h2>技术架构优势</h2>
<p>qiaojzx.cn 采用分布式云架构，具备以下技术优势：</p>
<ul>
<li><strong>高可用性：</strong>99.99% 的服务可用性保障，确保业务不中断。</li>
<li><strong>弹性扩展：</strong>根据业务负载自动调整资源配置，应对高峰流量。</li>
<li><strong>数据安全：</strong>银行级加密标准，全方位保护用户数据隐私。</li>
<li><strong>快速响应：</strong>全球 CDN 加速，页面加载速度领先行业标准。</li>
</ul>
<p>无论您是初次接触在线服务的新用户，还是寻求更高效解决方案的资深用户，qiaojzx.cn 都能为您提供超出预期的服务体验。立即注册，开启您的一站式服务之旅。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-15',
    readTime: '8 分钟',
    imageSeq: 'article-platform-overview',
    tags: ['平台介绍', '核心功能', '技术架构'],
  },
  {
    id: 'art-002',
    title: 'qiaojzx.cn 账号注册完整图文教程',
    slug: 'registration-guide',
    categorySlug: 'register-login',
    summary: '详细的 qiaojzx.cn 账号注册步骤指南，从访问官网到完成注册，每一步都有清晰的图文说明，确保您顺利完成账号创建。',
    content: `<p>注册 qiaojzx.cn 账号是使用平台全部功能的第一步。本教程将带您逐步完成注册流程，确保您能顺利创建自己的账户。</p>
<h2>注册前准备</h2>
<p>在开始注册之前，请确保您已准备好以下信息：</p>
<ul>
<li>一个有效的电子邮箱地址或手机号码</li>
<li>稳定的网络连接</li>
<li>符合安全要求的密码（建议包含大小写字母、数字和特殊字符）</li>
</ul>
<h2>步骤一：访问 qiaojzx.cn 官网</h2>
<p>打开浏览器，在地址栏输入 qiaojzx.cn，进入平台官方网站首页。在首页右上角可以看到"注册"按钮，点击即可进入注册页面。</p>
<p>您也可以直接在浏览器中输入 qiaojzx.cn/register 直接跳转到注册页面。</p>
<h2>步骤二：填写基本信息</h2>
<p>在注册页面中，您需要填写以下信息：</p>
<ul>
<li><strong>用户名：</strong>3-20 个字符，支持字母、数字和下划线</li>
<li><strong>电子邮箱：</strong>请使用有效的邮箱地址，后续可用于找回密码</li>
<li><strong>手机号码：</strong>用于接收验证码和重要通知</li>
<li><strong>登录密码：</strong>8-32 位，需包含至少两种字符类型</li>
<li><strong>确认密码：</strong>再次输入相同的密码以确认</li>
</ul>
<h2>步骤三：验证身份</h2>
<p>填写完基本信息后，系统会向您填写的手机号码发送一条短信验证码，同时向邮箱发送一封验证邮件。请在 5 分钟内完成验证码输入。</p>
<h2>步骤四：阅读并同意协议</h2>
<p>勾选"我已阅读并同意《用户服务协议》和《隐私政策》"选项。我们建议您仔细阅读这两份文件，了解您的权利和义务。</p>
<h2>步骤五：完成注册</h2>
<p>点击"立即注册"按钮，系统将自动创建您的账号。注册成功后，页面会自动跳转到登录状态，您可以立即开始使用 qiaojzx.cn 的各项服务。</p>
<h2>注册常见问题</h2>
<p><strong>Q: 收不到验证码怎么办？</strong></p>
<p>A: 请检查手机是否处于正常信号状态，确认未开启短信拦截功能。如仍无法收到，可点击"重新发送"按钮，或尝试使用邮箱验证方式。</p>
<p><strong>Q: 注册后可以修改用户名吗？</strong></p>
<p>A: 用户名是您在平台上的唯一标识，注册后不支持修改，请谨慎选择。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-10',
    readTime: '6 分钟',
    imageSeq: 'article-registration-guide',
    tags: ['注册教程', '新手指南', '账号管理'],
  },
  {
    id: 'art-003',
    title: 'qiaojzx.cn 登录方式全解析：快速登录与安全验证',
    slug: 'login-methods',
    categorySlug: 'register-login',
    summary: '全面解析 qiaojzx.cn 支持的多种登录方式，包括密码登录、短信验证码登录、扫码登录等，并介绍各项安全验证机制。',
    content: `<p>qiaojzx.cn 为用户提供了多种便捷的登录方式，同时配备了完善的安全验证机制，确保账户安全的同时兼顾使用便利性。</p>
<h2>支持的登录方式</h2>
<h3>1. 账号密码登录</h3>
<p>最基础的登录方式，使用注册时的用户名/邮箱/手机号 + 密码进行登录。建议开启二次验证以增强安全性。</p>
<h3>2. 短信验证码登录</h3>
<p>输入绑定的手机号码，接收短信验证码后即可完成登录。适合忘记密码或在不常用设备上登录的场景。</p>
<h3>3. 邮箱验证码登录</h3>
<p>与短信验证码登录类似，通过绑定的邮箱接收验证码完成身份验证。</p>
<h3>4. 扫码登录</h3>
<p>使用已登录 qiaojzx.cn 的手机端扫描网页端二维码，即可快速完成登录，无需输入密码。</p>
<h2>安全验证机制</h2>
<p>为保障您的账户安全，qiaojzx.cn 提供以下安全验证方式：</p>
<ul>
<li><strong>二次验证（2FA）：</strong>绑定 Google Authenticator 或类似验证器应用，每次登录需输入动态验证码。</li>
<li><strong>设备管理：</strong>查看和管理所有已登录设备，可随时远程下线可疑设备。</li>
<li><strong>登录通知：</strong>每次新设备登录时，系统会向您的绑定邮箱和手机发送通知。</li>
<li><strong>异常检测：</strong>系统自动检测异常登录行为，触发额外验证流程。</li>
</ul>
<h2>忘记密码处理</h2>
<p>如忘记登录密码，可在登录页面点击"忘记密码"，通过绑定的手机号或邮箱重置密码。重置链接有效期为 30 分钟，请及时完成操作。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-08',
    readTime: '5 分钟',
    imageSeq: 'article-login-methods',
    tags: ['登录教程', '安全验证', '账号管理'],
  },
  {
    id: 'art-004',
    title: 'qiaojzx.cn 智能搜索功能深度使用指南',
    slug: 'search-feature-guide',
    categorySlug: 'usage-tutorial',
    summary: '掌握 qiaojzx.cn 智能搜索的高级用法，学习如何使用筛选、排序、关键词组合等功能，快速精准地找到您需要的内容。',
    content: `<p>qiaojzx.cn 的智能搜索功能是平台的核心工具之一，掌握其高级用法将大幅提升您的使用效率。</p>
<h2>基础搜索</h2>
<p>在平台顶部搜索栏输入关键词，系统将自动匹配相关服务、文章和功能入口。支持模糊搜索和拼音搜索。</p>
<h2>高级搜索技巧</h2>
<h3>1. 精确匹配</h3>
<p>使用双引号包裹关键词，如"数据分析"，系统将返回完全匹配的结果。</p>
<h3>2. 多条件筛选</h3>
<p>搜索结果页支持按以下维度筛选：</p>
<ul>
<li>服务类型</li>
<li>发布时间</li>
<li>相关性排序</li>
<li>热度排序</li>
</ul>
<h3>3. 关键词组合</h3>
<p>使用空格分隔多个关键词，系统将返回同时包含所有关键词的结果。</p>
<h3>4. 排除关键词</h3>
<p>在关键词前加上减号，如"搜索 -高级"，可排除包含该词的结果。</p>
<h2>搜索结果解读</h2>
<p>每条搜索结果包含：标题、摘要、分类标签、发布时间和相关度评分。点击结果可直接进入对应页面。</p>
<h2>个性化推荐</h2>
<p>基于您的搜索历史和使用行为，系统会智能推荐可能感兴趣的内容，并在搜索结果中标注"为您推荐"标识。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-05',
    readTime: '7 分钟',
    imageSeq: 'article-search-guide',
    tags: ['使用教程', '搜索功能', '效率提升'],
  },
  {
    id: 'art-005',
    title: 'qiaojzx.cn 数据处理中心操作全流程',
    slug: 'data-center-guide',
    categorySlug: 'usage-tutorial',
    summary: '从数据导入到分析报表生成，完整介绍 qiaojzx.cn 数据处理中心的各项功能及操作流程，助您轻松驾驭数据。',
    content: `<p>qiaojzx.cn 数据处理中心是平台最强大的功能模块之一，提供从数据导入到可视化分析的全链路服务。</p>
<h2>数据导入</h2>
<p>数据处理中心支持多种数据导入方式：</p>
<ul>
<li><strong>文件上传：</strong>支持 CSV、Excel、JSON 等常见格式，单文件最大支持 100MB。</li>
<li><strong>API 接入：</strong>通过 RESTful API 实时同步外部数据源。</li>
<li><strong>数据库连接：</strong>支持 MySQL、PostgreSQL 等主流数据库直连。</li>
<li><strong>手动录入：</strong>适合小规模数据的快速录入。</li>
</ul>
<h2>数据清洗与预处理</h2>
<p>导入数据后，可使用平台提供的工具进行数据清洗：</p>
<ul>
<li>缺失值处理：自动识别并填充或标记缺失数据</li>
<li>格式标准化：统一日期、货币等数据格式</li>
<li>去重处理：智能识别并删除重复记录</li>
<li>异常值检测：基于统计模型标记异常数据点</li>
</ul>
<h2>数据分析工具</h2>
<p>平台内置丰富的分析工具：</p>
<ul>
<li><strong>描述性统计：</strong>均值、中位数、标准差、分布等基础统计量。</li>
<li><strong>趋势分析：</strong>时间序列分析和趋势预测。</li>
<li><strong>相关性分析：</strong>变量间的关联度计算和可视化。</li>
<li><strong>分组对比：</strong>按维度分组进行差异分析。</li>
</ul>
<h2>报表生成与导出</h2>
<p>分析完成后，可一键生成专业报表，支持导出为 PDF、Excel 或在线分享链接。报表模板可自定义，满足不同场景需求。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-01',
    readTime: '10 分钟',
    imageSeq: 'article-data-center',
    tags: ['使用教程', '数据处理', '数据分析'],
  },
  {
    id: 'art-006',
    title: 'qiaojzx.cn 安全体系全面解析：您的数据由我们守护',
    slug: 'security-system',
    categorySlug: 'service-advantages',
    summary: '深入了解 qiaojzx.cn 的多层安全防护体系，包括数据加密、访问控制、风险监控等核心安全机制。',
    content: `<p>在数字化时代，数据安全是每个用户最关心的问题之一。qiaojzx.cn 将安全放在首位，构建了多层次、全方位的安全防护体系。</p>
<h2>数据加密体系</h2>
<p>qiaojzx.cn 采用行业领先的加密技术保护用户数据：</p>
<ul>
<li><strong>传输加密：</strong>全站启用 TLS 1.3 协议，确保数据在传输过程中的安全性。</li>
<li><strong>存储加密：</strong>采用 AES-256 算法对敏感数据进行加密存储。</li>
<li><strong>密钥管理：</strong>使用硬件安全模块管理加密密钥，定期自动轮换。</li>
</ul>
<h2>访问控制机制</h2>
<ul>
<li><strong>基于角色的访问控制：</strong>精细化的权限管理，确保用户只能访问授权范围内的数据。</li>
<li><strong>多因素认证：</strong>支持密码 + 短信验证码 + 生物识别的多重验证。</li>
<li><strong>会话管理：</strong>自动检测异常会话，超时自动登出。</li>
</ul>
<h2>风险监控与响应</h2>
<ul>
<li><strong>实时威胁检测：</strong>7×24 小时自动化安全监控系统。</li>
<li><strong>入侵防御：</strong>智能 WAF 防火墙抵御各类网络攻击。</li>
<li><strong>安全审计：</strong>完整的操作日志记录，满足合规要求。</li>
</ul>
<h2>合规认证</h2>
<p>qiaojzx.cn 已通过多项国际安全认证，包括 ISO 27001 信息安全管理体系认证，确保平台安全标准达到国际水平。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-28',
    readTime: '7 分钟',
    imageSeq: 'article-security',
    tags: ['服务优势', '数据安全', '加密技术'],
  },
  {
    id: 'art-007',
    title: 'qiaojzx.cn 性能优势：快速响应与高并发处理能力',
    slug: 'performance-advantages',
    categorySlug: 'service-advantages',
    summary: '了解 qiaojzx.cn 卓越的性能表现背后的技术支撑，包括全球 CDN 加速、弹性计算资源、智能负载均衡等。',
    content: `<p>qiaojzx.cn 致力于为用户提供流畅的使用体验，在性能优化方面投入了大量技术资源。</p>
<h2>全球 CDN 加速</h2>
<p>qiaojzx.cn 在全球部署了超过 200 个 CDN 节点，覆盖亚洲、欧洲、北美、南美等主要区域。无论您身在何处，都能享受到毫秒级的页面加载速度。</p>
<h2>弹性计算架构</h2>
<ul>
<li><strong>自动扩缩容：</strong>根据实时流量自动调整计算资源，业务高峰期从容应对。</li>
<li><strong>容器化部署：</strong>基于 Kubernetes 的容器编排，实现服务的高效管理和快速部署。</li>
<li><strong>微服务架构：</strong>各功能模块独立部署，互不影响，单点故障不会导致全站不可用。</li>
</ul>
<h2>智能负载均衡</h2>
<p>多层负载均衡策略确保请求被智能分配到最优节点处理，避免单点过载。支持基于地理位置、服务器负载和网络延迟的动态路由。</p>
<h2>性能指标</h2>
<ul>
<li>平均页面加载时间：低于 1.5 秒</li>
<li>API 平均响应时间：低于 200 毫秒</li>
<li>系统可用性：99.99%</li>
<li>并发处理能力：支持百万级并发请求</li>
</ul>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-25',
    readTime: '6 分钟',
    imageSeq: 'article-performance',
    tags: ['服务优势', '性能优化', '技术架构'],
  },
  {
    id: 'art-008',
    title: 'qiaojzx.cn 移动端使用指南：随时随地享受便捷服务',
    slug: 'mobile-guide',
    categorySlug: 'usage-tutorial',
    summary: '介绍 qiaojzx.cn 移动端的各项功能与操作方式，让您在外出时也能高效使用平台服务。',
    content: `<p>qiaojzx.cn 提供了完整的移动端体验，让您随时随地都能使用平台服务。</p>
<h2>移动端访问方式</h2>
<ul>
<li><strong>移动网页版：</strong>通过手机浏览器访问 qiaojzx.cn，自动适配移动端界面。</li>
<li><strong>微信小程序：</strong>搜索"qiaojzx.cn"即可在微信内使用，无需下载安装。</li>
</ul>
<h2>移动端特色功能</h2>
<ul>
<li><strong>消息推送：</strong>重要通知实时送达，不错过任何关键信息。</li>
<li><strong>扫码功能：</strong>支持扫码登录网页端、扫码支付等快捷操作。</li>
<li><strong>手势操作：</strong>支持滑动、长按等手势，操作更自然流畅。</li>
<li><strong>离线缓存：</strong>关键内容支持离线查看，节省流量。</li>
</ul>
<h2>移动端与桌面端数据同步</h2>
<p>所有数据在移动端和桌面端实时同步，您在手机上进行的操作会自动同步到电脑端，反之亦然。切换设备无需担心数据丢失。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-20',
    readTime: '5 分钟',
    imageSeq: 'article-mobile-guide',
    tags: ['使用教程', '移动端', '跨平台'],
  },
  {
    id: 'art-009',
    title: '如何修改 qiaojzx.cn 账户信息与安全设置',
    slug: 'account-settings',
    categorySlug: 'faq',
    summary: '详细指导如何在 qiaojzx.cn 中修改个人资料、更换绑定手机/邮箱、调整隐私设置以及开启安全保护功能。',
    content: `<p>合理配置账户信息和安全设置，是保障您在 qiaojzx.cn 使用体验的重要环节。</p>
<h2>修改个人资料</h2>
<p>登录后进入"个人中心" &gt; "账户设置"，您可以修改以下信息：</p>
<ul>
<li>头像：支持 JPG、PNG 格式，建议尺寸 200×200 像素</li>
<li>昵称：30 天内仅可修改一次</li>
<li>个人简介：最多 200 字</li>
<li>所在地区</li>
</ul>
<h2>更换绑定信息</h2>
<p><strong>更换手机号：</strong>进入"安全设置"，点击"更换手机号"，需通过当前绑定手机号验证和新手机号验证。</p>
<p><strong>更换邮箱：</strong>与更换手机号流程类似，需要原邮箱和新邮箱的双重验证。</p>
<h2>隐私设置</h2>
<ul>
<li><strong>个人资料可见性：</strong>可设置为公开、仅好友可见或仅自己可见。</li>
<li><strong>操作动态：</strong>控制是否向他人展示您的平台操作记录。</li>
<li><strong>搜索可见性：</strong>设置是否允许通过搜索找到您的账户。</li>
</ul>
<h2>安全保护建议</h2>
<ul>
<li>定期更换登录密码，建议每 90 天更新一次</li>
<li>开启二次验证，增加账户安全层级</li>
<li>定期检查登录设备列表，移除不常用设备</li>
<li>不要与他人共享账户信息</li>
</ul>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-18',
    readTime: '6 分钟',
    imageSeq: 'article-account-settings',
    tags: ['常见问题', '账户设置', '安全'],
  },
  {
    id: 'art-010',
    title: 'qiaojzx.cn 付费服务与订阅管理说明',
    slug: 'payment-subscription',
    categorySlug: 'faq',
    summary: '全面解答 qiaojzx.cn 付费服务的定价、订阅方式、支付渠道、发票开具以及退款政策等用户关心的核心问题。',
    content: `<p>qiaojzx.cn 提供基础免费服务和高级付费服务两种模式，满足不同用户的多样化需求。</p>
<h2>服务等级说明</h2>
<ul>
<li><strong>免费版：</strong>提供基础功能，适合个人用户日常使用。</li>
<li><strong>专业版：</strong>解锁高级功能，适合专业用户和小型团队。</li>
<li><strong>企业版：</strong>完整功能 + 专属支持，适合中大型企业。</li>
</ul>
<h2>支付方式</h2>
<p>qiaojzx.cn 支持以下支付渠道：</p>
<ul>
<li>支付宝</li>
<li>微信支付</li>
<li>银联在线支付</li>
<li>对公银行转账（企业版）</li>
</ul>
<h2>订阅管理</h2>
<p>在"个人中心" &gt; "我的订阅"中，您可以：</p>
<ul>
<li>查看当前订阅状态和到期时间</li>
<li>升级或降级服务等级</li>
<li>开启/关闭自动续费</li>
<li>查看历史账单和消费记录</li>
</ul>
<h2>发票与退款</h2>
<p><strong>发票：</strong>支持电子发票和纸质发票，可在消费后 30 天内申请开具。</p>
<p><strong>退款：</strong>购买后 7 天内如未使用付费功能，可申请全额退款。部分特殊服务除外，具体以页面说明为准。</p>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-15',
    readTime: '7 分钟',
    imageSeq: 'article-payment',
    tags: ['常见问题', '付费服务', '订阅管理'],
  },
  {
    id: 'art-011',
    title: 'qiaojzx.cn 客户服务体系：多渠道全天候支持',
    slug: 'customer-service',
    categorySlug: 'service-advantages',
    summary: '介绍 qiaojzx.cn 完善的客户服务体系，包括在线客服、工单系统、帮助中心、社区论坛等多渠道支持方式。',
    content: `<p>qiaojzx.cn 建立了完善的客户服务体系，确保用户在使用过程中遇到任何问题都能得到及时有效的帮助。</p>
<h2>在线客服</h2>
<p>平台内置在线客服系统，工作时间（周一至周日 9:00-21:00）提供实时响应。非工作时间可留言，客服将在次日优先处理。</p>
<h2>工单系统</h2>
<p>对于需要跟踪处理的问题，可提交工单。每个工单都有唯一的编号和处理状态，用户可随时查看处理进度。</p>
<h2>帮助中心</h2>
<p>平台内置丰富的帮助文档和视频教程，覆盖全部功能模块。支持关键词搜索，快速定位解决方案。</p>
<h2>社区论坛</h2>
<p>qiaojzx.cn 用户社区汇集了大量经验丰富的用户，您可以在社区中提问、分享经验、交流技巧。官方团队也会定期在社区发布更新公告和使用技巧。</p>
<h2>服务承诺</h2>
<ul>
<li>在线咨询：3 分钟内响应</li>
<li>工单处理：24 小时内首次回复</li>
<li>紧急问题：专属通道，1 小时内响应</li>
</ul>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-06-12',
    readTime: '5 分钟',
    imageSeq: 'article-customer-service',
    tags: ['服务优势', '客户服务', '用户支持'],
  },
  {
    id: 'art-012',
    title: 'qiaojzx.cn 平台更新日志与版本说明',
    slug: 'changelog',
    categorySlug: 'faq',
    summary: '查看 qiaojzx.cn 最新的平台更新内容，了解新增功能、优化改进和问题修复详情。',
    content: `<p>qiaojzx.cn 团队持续对平台进行优化和迭代，以下是近期的更新记录。</p>
<h2>v3.2.0（2026年7月）</h2>
<ul>
<li><strong>新增：</strong>智能搜索支持语音输入</li>
<li><strong>新增：</strong>数据处理中心支持更多图表类型</li>
<li><strong>优化：</strong>页面加载速度提升 30%</li>
<li><strong>修复：</strong>若干已知问题</li>
</ul>
<h2>v3.1.0（2026年6月）</h2>
<ul>
<li><strong>新增：</strong>微信小程序版本上线</li>
<li><strong>新增：</strong>支持扫码登录网页端</li>
<li><strong>优化：</strong>移动端界面交互体验</li>
</ul>
<h2>v3.0.0（2026年5月）</h2>
<ul>
<li><strong>新增：</strong>全新数据处理中心上线</li>
<li><strong>新增：</strong>即时通讯系统</li>
<li><strong>重构：</strong>整体 UI 界面升级</li>
</ul>`,
    author: 'qiaojzx.cn 官方团队',
    publishDate: '2026-07-20',
    readTime: '4 分钟',
    imageSeq: 'article-changelog',
    tags: ['常见问题', '更新日志', '版本说明'],
  },
];

export const getArticleBySlug = (slug: string) => articles.find((a) => a.slug === slug);
export const getArticlesByCategory = (categorySlug: string) => articles.filter((a) => a.categorySlug === categorySlug);
export const getRelatedArticles = (currentSlug: string, categorySlug: string, limit: number = 4) =>
  articles.filter((a) => a.categorySlug === categorySlug && a.slug !== currentSlug).slice(0, limit);